import React from "react"
import styled from "styled-components"

import GoogleAi from "../../../assets/images/svg/ai/google-ai.svg"
import Grok from "../../../assets/images/svg/ai/grok.svg"
import ChatGpt from "../../../assets/images/svg/ai/chatgpt.svg"
import Perplexity from "../../../assets/images/svg/ai/perplexity.svg"
import Claude from "../../../assets/images/svg/ai/claude.svg"

import { UnstyledList, VisuallyHidden } from "../common/essentials"
import { SITE_URL } from "../../../utils/seoUrls"

import SiteLanguage from "../../../helpers/siteLanguage"

const Container = styled.div`
  margin-bottom: 35px;
`

const Title = styled.p`
  margin-bottom: 0.8rem;

  font-size: 1.1rem;
  font-weight: 600;
  color: #fff;
`

const List = styled(UnstyledList)`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`

const Link = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;

  color: #fff;
  background-color: var(--dark-gray);

  transition: background-color 200ms ease;

  &:hover {
    background-color: var(--line-gray);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`

// Each assistant opens with a prompt asking it to summarise the site.
const ASSISTANTS = [
  {
    name: "Google AI",
    Icon: GoogleAi,
    url: q => `https://www.google.com/search?q=${q}&udm=50`,
  },
  { name: "Grok", Icon: Grok, url: q => `https://grok.com/?q=${q}` },
  { name: "ChatGPT", Icon: ChatGpt, url: q => `https://chatgpt.com/?q=${q}` },
  {
    name: "Perplexity",
    Icon: Perplexity,
    url: q => `https://www.perplexity.ai/search/?q=${q}`,
  },
  { name: "Claude", Icon: Claude, url: q => `https://claude.ai/new?q=${q}` },
]

const AiSummary = () => {
  const isEnglish = SiteLanguage() === "en"

  const prompt = isEnglish
    ? `Visit ${SITE_URL}/ and answer: what does Brave New do, who is it for, and why should I work with them?`
    : `Odwiedź ${SITE_URL}/pl/ i odpowiedz: czym zajmuje się Brave New, dla kogo pracuje i dlaczego warto z nimi współpracować?`
  const query = encodeURIComponent(prompt)

  return (
    <Container>
      <Title>{isEnglish ? "Explore AI Summary" : "Podsumowanie w AI"}</Title>
      <List>
        {ASSISTANTS.map(({ name, Icon, url }) => (
          <li key={name}>
            <Link
              href={url(query)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon aria-hidden="true" />
              {/* Anchor text for crawlers and screen readers; only the icon shows. */}
              <VisuallyHidden>
                {isEnglish ? `Summarise in ${name}` : `Podsumuj w ${name}`}
              </VisuallyHidden>
            </Link>
          </li>
        ))}
      </List>
    </Container>
  )
}

export default AiSummary
